// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TasksAssignee from './data'

export default function TasksAssigneeFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TasksAssignee">
      <TasksAssignee {...props}>
        {children}
      </TasksAssignee>
    </Flow>
  )
}
